<template>
  <div class="c-study-top-nav">
    <router-link class="c-study-top-nav-logo" to="/">
      <img src="../../../static/images/logo.png" alt="">
    </router-link>
    <p v-if="current">
      <router-link :to="`/program/${this.$route.params.id}`" class="c-study-top-nav-link">{{lessonInfo.title}}</router-link>
      <span class="c-study-top-nav-current">&nbsp;/&nbsp;{{current.title}}</span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    current: {
      type: Object,
      default: null
    },
    lessonInfo: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss">
.c-study-top-nav{
  height: 55px;
  position: absolute;
  box-shadow: 0px 3px 6px rgba(0,0,0,.16);
  line-height: 55px;
  z-index: 10;
  width: 100%;
  background-color: #fff;
  .c-study-top-nav-logo{
    position: absolute;
    left: 18px;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    background-color: #FE5454;
    border-radius: 50%;
    text-align: center;
    overflow: hidden;
    display: block;
    img{
      width: 14.6px;
      height: 21px;
      vertical-align: top;
      margin-top: 4px;
    }
  }
  p{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin-left: 58px;
    color: #5C5F63;
    font-size: 14px;
    line-height: 14px;
    .c-study-top-nav-link{
      text-decoration: none;
      color: #5C5F63;
      font-weight: 700;
    }
  }
}
</style>
